import { Action, MetaReducer, createReducer } from '@ngrx/store';
import { HttpStateHandler } from '@shared/utils/classes/http-state-handler';
import { produceOn, transferStateMetaReducer } from '@shared/utils/functions/store.function';
import { HttpState } from '@shared/utils/models/http.model';
import {
  PublicOfferFormDetails,
  SendPublicOfferFormResponse,
} from '@features/public-offer-form/utils/models/public-offer-form.model';
import { PublicOfferFormActions, PublicOfferFormResetActions } from '../actions/public-offer-form.actions';

export const publicOfferFormFeatureKey = 'publicOfferForm';

export interface State {
  userId: number | null;
  data: PublicOfferFormDetails | null;
  httpState: HttpState;
  send: {
    httpState: HttpState;
    data: SendPublicOfferFormResponse | null;
  };
}

export const initialState: State = {
  userId: null,
  data: null,
  httpState: HttpStateHandler.initialState,
  send: {
    httpState: HttpStateHandler.initialState,
    data: null,
  },
};

export const publicOfferFormReducer = createReducer(
  initialState,
  produceOn(PublicOfferFormActions.validateOfferForm, (draft, action) => {
    draft.userId = action.userId;
    draft.data = initialState.data;
    draft.httpState = HttpStateHandler.loading(draft.httpState, action);
  }),
  produceOn(PublicOfferFormActions.validateOfferFormSuccess, (draft, action) => {
    draft.data = action.data;
    draft.httpState = HttpStateHandler.success(draft.httpState, action);
  }),
  produceOn(PublicOfferFormActions.validateOfferFormFailure, (draft, action) => {
    draft.httpState = HttpStateHandler.error(draft.httpState, action);
  }),
  produceOn(PublicOfferFormActions.sendOfferForm, (draft, action) => {
    draft.send.data = initialState.send.data;
    draft.send.httpState = HttpStateHandler.loading(draft.send.httpState, action);
  }),
  produceOn(PublicOfferFormActions.sendOfferFormSuccess, (draft, action) => {
    draft.send.data = action.data;
    draft.send.httpState = HttpStateHandler.success(draft.send.httpState, action);
  }),
  produceOn(PublicOfferFormActions.sendOfferFormFailure, (draft, action) => {
    draft.send.httpState = HttpStateHandler.error(draft.send.httpState, action);
  }),
  produceOn(PublicOfferFormResetActions.cancelPublicOfferFormActionsSuccess, (draft) => {
    draft.httpState = HttpStateHandler.initialState;
  }),
  produceOn(PublicOfferFormResetActions.resetPublicOfferForm, (draft) => {
    draft.userId = initialState.userId;
    draft.data = initialState.data;
    draft.httpState = initialState.httpState;
    draft.send = initialState.send;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return publicOfferFormReducer(state, action);
}

export const metaReducers: MetaReducer<State>[] = [
  transferStateMetaReducer(publicOfferFormFeatureKey, initialState, false),
];
